/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaginationMetaDto
 */
export interface PaginationMetaDto {
    /**
     * Total items across all pages
     * @type {number}
     * @memberof PaginationMetaDto
     */
    total: number;
    /**
     * Current page number
     * @type {number}
     * @memberof PaginationMetaDto
     */
    page: number;
    /**
     * Items per page
     * @type {number}
     * @memberof PaginationMetaDto
     */
    limit: number;
    /**
     * Total number of pages
     * @type {number}
     * @memberof PaginationMetaDto
     */
    totalPages: number;
}

/**
 * Check if a given object implements the PaginationMetaDto interface.
 */
export function instanceOfPaginationMetaDto(value: object): value is PaginationMetaDto {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PaginationMetaDtoFromJSON(json: any): PaginationMetaDto {
    return PaginationMetaDtoFromJSONTyped(json, false);
}

export function PaginationMetaDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationMetaDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'totalPages': json['totalPages'],
    };
}

export function PaginationMetaDtoToJSON(json: any): PaginationMetaDto {
    return PaginationMetaDtoToJSONTyped(json, false);
}

export function PaginationMetaDtoToJSONTyped(value?: PaginationMetaDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'totalPages': value['totalPages'],
    };
}

